import React, { useEffect, useMemo, useState, forwardRef } from "react";

export function useSpring(config = {}) {
  const initial = config.from ?? {};
  const [style, setStyle] = useState(initial);
  const target = config.to ?? config;
  const deps = useMemo(() => JSON.stringify(target), [target]);
  useEffect(() => {
    // No animation, just jump to target values
    setStyle(target);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deps]);
  return style;
}

function makeElement(tag) {
  return forwardRef(function AnimatedTag(props, ref) {
    const { children, ...rest } = props;
    return React.createElement(tag, { ref, ...rest }, children);
  });
}

// Minimal animated proxy that returns basic elements
export const animated = new Proxy(
  {},
  {
    get(_, tag) {
      return makeElement(tag);
    },
  }
);

export default { useSpring, animated };
